export default "__VITE_ASSET__1d4b749e__"